import { useEffect, useMemo, useState } from 'react';
import { Typography } from '@mui/material';

import { useProposalsSWR } from 'src/hooks/SWR/cosmos/useProposalsSWR';
import { pageView } from 'src/utils/ga';
import { gt } from 'src/utils/number';

import ProposalButton from './components/ProposalButton';
import VoteBottomSheet from './components/VoteBottomSheet';
import {
  Base02TextContainer,
  BodyContainer,
  FinishedProposalContainer,
  ProposalButtonContainer,
  ProposalTitleContainer,
  TitleContainer,
  TopHeaderContainer,
  VotingProposalContainer,
  Wrapper,
  WrapperContainer,
} from './styled';

export default function Governance() {
  const [selectedProposalId, setSelectedProposalId] = useState('');

  const [isOpenVoteBottomsheet, setIsOpenVoteBottomsheet] = useState(false);

  const proposals = useProposalsSWR({ proposalStatus: '0' });

  const votingProposals = useMemo(
    () => proposals.data?.proposals?.filter((item) => item.status === 'PROPOSAL_STATUS_VOTING_PERIOD').sort((a, b) => (gt(a.id, b.id) ? -1 : 1)) || [],
    [proposals.data?.proposals],
  );

  const finishedProposals = useMemo(
    () => proposals.data?.proposals?.filter((item) => item.status === 'PROPOSAL_STATUS_PASSED').sort((a, b) => (gt(a.id, b.id) ? -1 : 1)) || [],
    [proposals.data?.proposals],
  );

  useEffect(() => {
    pageView('Governance', 'Governance');
  }, []);

  return (
    <>
      <TopHeaderContainer>
        <TitleContainer>
          <Typography variant="h1">GOVERNANCE</Typography>
        </TitleContainer>
      </TopHeaderContainer>
      <BodyContainer>
        {!!votingProposals.length && (
          <VotingProposalContainer>
            <ProposalTitleContainer>
              <Typography variant="h6">Live Proposal</Typography>
              &nbsp;
              <Base02TextContainer>
                <Typography variant="h6">{votingProposals.length || '0'}</Typography>
              </Base02TextContainer>
            </ProposalTitleContainer>
            <ProposalButtonContainer>
              {votingProposals.map((item) => (
                <ProposalButton
                  key={item.id}
                  proposalId={item.id}
                  onClick={(proposalId) => {
                    setSelectedProposalId(proposalId);
                    setIsOpenVoteBottomsheet(true);
                  }}
                />
              ))}
            </ProposalButtonContainer>
          </VotingProposalContainer>
        )}

        {!!finishedProposals.length && (
          <Wrapper>
            <FinishedProposalContainer data-is-restricted={votingProposals.length > 2}>
              <ProposalTitleContainer>
                <Typography variant="h6">Finished Proposal</Typography>
                &nbsp;
                <Base02TextContainer>
                  <Typography variant="h6">{finishedProposals.length || '0'}</Typography>
                </Base02TextContainer>
              </ProposalTitleContainer>
              <ProposalButtonContainer>
                {finishedProposals.map((item) => (
                  <ProposalButton
                    key={item.id}
                    proposalId={item.id}
                    onClick={(proposalId) => {
                      setSelectedProposalId(proposalId);
                    }}
                  />
                ))}
              </ProposalButtonContainer>
            </FinishedProposalContainer>
          </Wrapper>
        )}
      </BodyContainer>

      <WrapperContainer data-is-open={isOpenVoteBottomsheet}>
        <VoteBottomSheet
          open={isOpenVoteBottomsheet}
          selectedProposalId={selectedProposalId}
          variant="persistent"
          onClose={() => {
            setIsOpenVoteBottomsheet(false);
          }}
        />
      </WrapperContainer>
    </>
  );
}
